import * as React from "react";
import { ToolTipButton } from "nsitools-react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";
import { Intent } from "@blueprintjs/core";
import { useAuth } from "../../contexts";

interface IViewButtonProps extends ICustomButtonProps {
  secured?: boolean;
}

export const ViewButton: React.FunctionComponent<IViewButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  text,
  disabled,
  intent = Intent.NONE,
  secured = true,
}) => {
  const { t } = useTl();
  const { getCurrentPermission } = useAuth();
  const hasRights = React.useMemo(() => getCurrentPermission()?.permission.includes("R"), [getCurrentPermission]);
  return (
    <ToolTipButton
      icon={IconNames.EYE_OPEN}
      tooltip={text ? text : t(ETLCodes.General_View)}
      minimal={minimal}
      onClick={onClick}
      text={text ? text : minimal ? null : t(ETLCodes.General_View)}
      intent={intent}
      loading={loading}
      disabled={disabled || (secured && !hasRights)}
    />
  );
};
